/* eslint-disable @typescript-eslint/naming-convention */
export abstract class PERIOD {
  static readonly MONTH: string = "month";
  static readonly WEEK: string = "week";
  static readonly DAY: string = "day";
};

export abstract class TASK_MODEL_ACTIONS {
  static readonly OER_CONVERSION_PROCESS_STARTED: string = "oerConversionProcess_started";
  static readonly OER_CONVERSION_PROCESS_FINISHED: string = "oerConversionProcess_finished";
  static readonly FIRST_STEPS_DIALOG_STARTED: string = "firstStepsDialog_started";
  static readonly FIRST_STEPS_DIALOG_FINISHED: string = "firstStepsDialog_finished";
  static readonly FILE_IMPORTED: string = "file_imported";
  static readonly IMAGE_LISTED: string = "image_listed";
  static readonly IMAGE_SELECTED: string = "image_selected";
  static readonly EXTERNAL_IMAGE_SEARCHED: string = "externalImage_searched";
  static readonly EXTERNAL_IMAGE_FETCHED: string = "externalImage_fetched";
  static readonly IMAGE_EDITED: string = "image_edited";
  static readonly IMAGE_REPLACED: string = "image_replaced";
  static readonly REPLACED_IMAGE_UNDID: string = "replacedImage_undid";
};

export abstract class RESULT_STORE_ENPOINTS {
  static readonly GEOGRAPHIC_TRAFFIC_FREQUENCY: string = "/result-store/convoerter_logs_engines/geographic_traffic";
  static readonly SESSION_FREQUENCY: string = "/result-store/convoerter_logs_engines/session_frequency";
  static readonly BROWSER_FREQUENCY: string = "/result-store/convoerter_logs_engines/browser_frequency";
  static readonly TOOL_VERSION_FREQUENCY: string = "/result-store/convoerter_logs_engines/tool_version_frequency";
  static readonly TOOL_LANG_FREQUENCY: string = "/result-store/convoerter_logs_engines/tool_language_frequency";

  static readonly FILE_IMPORT_FREQUENCY: string = "/result-store/convoerter_logs_engines/file_import_frequency";
  static readonly EXTERNAL_SEARCH_FREQUENCY: string = "/result-store/convoerter_logs_engines/external_search_frequency";
  static readonly MANUAL_REPLACEMENT_FREQUENCY: string = "/result-store/convoerter_logs_engines/manual_replacement_frequency";

  static readonly PUBLISH_AS_OER_FREQUENCY: string = "/result-store/convoerter_logs_engines/publish_as_oer_frequency";
  static readonly EXCLUDE_IMAGE_FREQUENCY: string = "/result-store/convoerter_logs_engines/exclude_from_license_frequency";
  static readonly SAVE_CLICKED_FREQUENCY: string = "/result-store/convoerter_logs_engines/save_button_click_frequency";

  static readonly FILE_TYPE_FREQUENCY: string = "/result-store/convoerter_logs_engines/file_type_frequency";
  static readonly IMAGE_TYPE_FREQUENCY: string = "/result-store/convoerter_logs_engines/image_type_frequency";
  static readonly TARGET_LICENCE_TYPE_FREQUENCY: string = "/result-store/convoerter_logs_engines/target_license_type_frequency";

  static readonly SAVE_AND_IMAGE_LISTED_FREQUENCY: string = "/result-store/convoerter_logs_engines/bounce_rate_save_imagelist_frequency";
  static readonly SAVE_AND_START_CLICKED_FREQUENCY: string = "/result-store/convoerter_logs_engines/bounce_rate_save_start_frequency";
  static readonly START_AND_HOME_LOADED_FREQUENCY: string = "/result-store/convoerter_logs_engines/bounce_rate_start_home_frequency";

  static readonly FILE_IMPORT_AVG_TIME: string = "/result-store/convoerter_logs_engines/file_import_avg_time";
  static readonly EXTERNAL_SEARCH_AVG_TIME: string = "/result-store/convoerter_logs_engines/external_search_avg_time";
  static readonly EXTERNAL_SEARCH_FETCH_AVG_TIME: string = "/result-store/convoerter_logs_engines/external_search_fetch_avg_time";
  static readonly MANUAL_REPLACEMENT_AVG_TIME: string = "/result-store/convoerter_logs_engines/manual_replacement_avg_time";
  static readonly OVERALL_SESSION_AVG_TIME: string = "/result-store/convoerter_logs_engines/overall_session_avg_time";

  static readonly TOTAL_IMAGES_FREQUENCY: string = "/result-store/convoerter_logs_engines/total_images_frequency";
  static readonly PROCESSED_IMAGES_FREQUENCY: string = "/result-store/convoerter_logs_engines/processed_images_frequency";

  static readonly EXTERNAL_SEARCH_AUTO_QUERY_CLICKED_FREQUENCY: string = "/result-store/convoerter_logs_engines/external_search_auto_query_clicked_frequency";
  static readonly EXTERNAL_SEARCH_AUTO_QUERY_OPTION_CLICKED_FREQUENCY: string = "/result-store/convoerter_logs_engines/external_search_auto_query_options_clicked_frequency";
  static readonly EXTERNAL_SEARCH_SEARCHED_FREQUENCY: string = "/result-store/convoerter_logs_engines/external_search_searched_frequency";
  static readonly EXTERNAL_SEARCH_MANUALLY_REPLACED_FREQUENCY: string = "/result-store/convoerter_logs_engines/external_search_manually_replaced_frequency";
  static readonly EXTERNAL_SEARCH_TARGET_APIS_FREQUENCY: string = "/result-store/convoerter_logs_engines/external_search_target_apis_frequency";
  static readonly EXTERNAL_SEARCH_TARGET_LICENSES_FREQUENCY: string = "/result-store/convoerter_logs_engines/external_search_targeted_licenses_frequency";

  static readonly SESSION_IDS: string = "/result-store/convoerter_logs_engines/session_ids";
  static readonly TASK_MODEL: string = "/result-store/convoerter_logs_engines/task_model";

  static readonly FEEDBACK_WAS_HELPFUL_FREQUENCY: string = "/result-store/convoerter_logs_engines/feedback_wasHelpful_frequency";
  static readonly FEEDBACK_UI_IS_GOOD_FREQUENCY: string = "/result-store/convoerter_logs_engines/feedback_uiIsGood_frequency";
  static readonly FEEDBACK_I_WILL_USE_IT_FREQUENCY: string = "/result-store/convoerter_logs_engines/feedback_iWillUseIt_frequency";
  static readonly FEEDBACK_MAJOR_PROBLEMS_FREQUENCY: string = "/result-store/convoerter_logs_engines/feedback_majorProblems_frequency";

};
